import * as React from 'react'
import { Segment, Container, Icon } from 'semantic-ui-react'

export default () =>
<Segment inverted vertical style={{ position: 'absolute', bottom: 0, width: '100%' }}>
  <Container textAlign='center'>
    <p>
      Made with <Icon name='heart' color='red' /> by
      <a target='_blank' href='//github.com/vicentedealencar'> vicentedealencar</a>
    </p>
  </Container>
</Segment>
